import { ReactNode } from 'react'
import { ITermsConfirmation, IUserSession } from 'types'

export const TERMS_CONFIRMATIONS: ReadonlyArray<{
  id: ITermsConfirmation
  label: ReactNode
}> = [
  {
    id: 'ai_support_tool',
    label: (
      <>
        Concordo que a AI é uma <em>ferramenta de apoio</em>, não substitui a
        avaliação médica.
      </>
    )
  },
  {
    id: 'professional_responsibility',
    label:
      'Concordo que o profissional de saúde é sempre responsável pelo diagnóstico final.'
  },
  {
    id: 'clinical_context',
    label:
      'Concordo que resultados devem ser interpretados no contexto clínico do paciente.'
  }
]

/** Whether the session still lacks the terms or any of the AI confirmations */
export const isTermsAcceptancePending = (
  user: Pick<IUserSession, 'terms_accepted' | 'accepted_confirmations'>
) => {
  const accepted = user.accepted_confirmations ?? []
  return (
    user.terms_accepted !== true ||
    TERMS_CONFIRMATIONS.some(({ id }) => !accepted.includes(id))
  )
}
